import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const HELP_CENTER_VIEW_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/help-center',
        name: '::Menu:HelpCenter',
        layout: eLayoutType.application,
        iconClass:'fas fa-exclamation-circle',
        requiredPolicy: 'ReturnLy.Topics && ReturnLy.FrequentlyAskedQuestions',
        order:3
      },
    ]);
  };
}
